//product_page

$('.quantity__button_custom_minus').click(function(){
  custom_quantity = parseFloat($('.quantity__input_custom').val()).toFixed(1);
  if(custom_quantity > 0.3){
    minus_quantity = parseFloat(custom_quantity-(0.1)).toFixed(1);
    $('.quantity__input_custom').val(minus_quantity)
    $('.main_quantity_change').val(minus_quantity*10)
    $('.quantity_in_cm').text(Math.round(minus_quantity*100) +'cm')
  }
})

$('.quantity__button_custom_plus').click(function(){
  new_custom_quantity = $('.quantity__input_custom').val();
    plus_quantity = parseFloat(new_custom_quantity) + 0.1;
  plus_input = parseFloat(plus_quantity).toFixed(1)
    $('.quantity__input_custom').val(plus_input)
    $('.main_quantity_change').val(plus_input*10)
    $('.quantity_in_cm').text(Math.round(plus_input*100)+'cm')
  
})

$('.quantity__input_custom').change(function(){
  fetched_quantity = parseFloat($(this).val()).toFixed(1);
  $('.main_quantity_change').val(fetched_quantity*10);
  $('.quantity_in_cm').text(Math.round(fetched_quantity*100)+'cm')
})

//cart page 
$('body').delegate('.cart_quantity__button_custom_minus','click',function(){
  cart_minus_quantity = parseFloat($(this).next().val()).toFixed(1);
  if(cart_minus_quantity > 0.3){
    input_minus_quantity = parseFloat(cart_minus_quantity-(0.1)).toFixed(1);
    $(this).next().val(input_minus_quantity)
    $(this).parent().prev().find('.cart_quantity_input').val(input_minus_quantity*10)
    cart_var_id = $(this).parent().prev().find('.cart_quantity_input').data('quantity-variant-id');
    cart_var_val = $(this).parent().prev().find('.cart_quantity_input').val();
    jQuery.post('/cart/change.js', { quantity: parseInt(cart_var_val), id: cart_var_id })
    setTimeout(function(){
    $('#main-cart-items').load(' #main-cart-items')
    $('#cart-icon-bubble').load(' #cart-icon-bubble') 
    $('#cart-live-region-text').load(' #cart-live-region-text') 
    $('#main-cart-footer').load(' #main-cart-footer')
    },1000)
  }
})

$('body').delegate('.cart_quantity__button_custom_plus','click',function(){
  new_custom_quantity = $(this).prev().val();
  plus_quantity = parseFloat(new_custom_quantity) + 0.1;
  plus_input = parseFloat(plus_quantity).toFixed(1)
  $(this).prev().val(plus_input)
  $(this).parent().prev().find('.cart_quantity_input').val(plus_input*10)
  cart_var_id = $(this).parent().prev().find('.cart_quantity_input').data('quantity-variant-id');
  cart_var_val = parseInt($(this).parent().prev().find('.cart_quantity_input').val())
  jQuery.post('/cart/change.js', { quantity: parseInt(cart_var_val), id: cart_var_id })
  setTimeout(function(){
  $('#main-cart-items').load(' #main-cart-items')
  $('#cart-icon-bubble').load(' #cart-icon-bubble') 
  $('#cart-live-region-text').load(' #cart-live-region-text') 
  $('#main-cart-footer').load(' #main-cart-footer')
  },1000)
})

$('body').delegate('.cart_quantity__input_custom','change',function(){
  cart_fetched_quantity = parseFloat($(this).val()).toFixed(1);
  $(this).parent().prev().find('.cart_quantity_input').val(cart_fetched_quantity*10);
  cart_var_id = $(this).parent().prev().find('.cart_quantity_input').data('quantity-variant-id');
  cart_var_val = $(this).parent().prev().find('.cart_quantity_input').val();
  jQuery.post('/cart/change.js', { quantity: parseInt(cart_var_val), id: cart_var_id })
  setTimeout(function(){
  $('#main-cart-items').load(' #main-cart-items')
  $('#cart-icon-bubble').load(' #cart-icon-bubble') 
  $('#cart-live-region-text').load(' #cart-live-region-text') 
  $('#main-cart-footer').load(' #main-cart-footer')
  },1000)
})

$('.ced_variant').change(function(){
  setTimeout(function(){
   $('#available_stock_wrapper').load(' #available_stock_wrapper') 
  },500)
  
})